export const sortingStringComparer = (recordA?: string, recordB?: string) => {
    if (!recordA || !recordB) {
        return -1;
    }

    if (recordA.toLowerCase() < recordB.toLowerCase()) {
        return -1;
    }

    if (recordA.toLowerCase() > recordB.toLowerCase()) {
        return 1;
    }

    return 0;
}

export const sortingNumberComparer = (recordA?: number, recordB?: number) => {
    if (!recordA || !recordB) {
        return -1;
    }

    if (recordA < recordB) {
        return -1;
    }

    if (recordA > recordB) {
        return 1;
    }

    return 0;
}

export const sortingDateComparer = (recordA?: string, recordB?: string) => {
    if (new Date(recordA || 0).getTime() < new Date(recordB || 0).getTime()) {
        return -1;
    }

    if (new Date(recordA || 0).getTime() > new Date(recordB || 0).getTime()) {
        return 1;
    }

    return 0;
}